// extracted by mini-css-extract-plugin
export default {"platformPicker":"PlatformPicker_platformPicker__XBFWm"};